



















































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositCoolingOffSettings from "@/models/Products/ProductSettings/DefaultSettings/CoolingOff/CoolingOffSettings";
import DepositCoolingOffSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/CoolingOff/DepositCoolingOffSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositCoolingOffSettingsRead', components: { ProductState, DepositCoolingOffSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositCoolingOffSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }

}
